var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 3.33329C8.61929 3.33329 7.5 4.45258 7.5 5.83329C7.5 7.214 8.61929 8.33329 10 8.33329C11.3807 8.33329 12.5 7.214 12.5 5.83329C12.5 4.45258 11.3807 3.33329 10 3.33329ZM5.83333 5.83329C5.83333 3.53211 7.69881 1.66663 10 1.66663C12.3012 1.66663 14.1667 3.53211 14.1667 5.83329C14.1667 8.13448 12.3012 9.99996 10 9.99996C7.69881 9.99996 5.83333 8.13448 5.83333 5.83329Z",
    fill: "black",
    fillOpacity: 0.76
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.66667 13.3333C5.28595 13.3333 4.16667 14.4526 4.16667 15.8333V18.3333H2.5V15.8333C2.5 13.5321 4.36548 11.6666 6.66667 11.6666H13.3333C15.6345 11.6666 17.5 13.5321 17.5 15.8333V18.3333H15.8333V15.8333C15.8333 14.4526 14.714 13.3333 13.3333 13.3333H6.66667Z",
    fill: "black",
    fillOpacity: 0.76
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user-icon.fdb804b96af7e44388c4a5b521e36063.svg";
export { ForwardRef as ReactComponent };